import React, { Component } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import toastr from 'toastr';
import { withStyles } from '@mui/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SharedPieChart from './sharedPieChart';
import Competitor from './competitor';

import sharedAccountsApi from '../api/sharedAccountsApi';

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
        color: '#78BE43'
    },
    input: {
        display: 'none',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    textAlign: 'center'
});
const theme = createTheme({
    palette: {
        primary: {
            light: '#93cb68',
            main: '#78BE43',
            dark: '#54852e',
            contrastText: '#fff',
        },
    },
});
const colors = [
    '#4286f4',
    '#8e41f4',
    '#e541f4',
    '#f4417c',
    '#f44143',
    '#f45e41',
    '#f47c41',
    '#f4a341',
    '#f4e841',
    '#76f441',
    '#41f479',
    '#41f4b5',
    '#41f4d3'
];

class Item extends Component {

    state = {
        selectedCompetitor: null,
        competitors: [],
        percentage: '',
        otherCompetitor: '',
        totalSelected: 0,
        totalOtherSelected: 0,
        showOtherField: false,
        status: "In Process",
        openSubmit: false,
        openReset: false,
        isSubmitting: false,
        colorIndex: 0,
        isDirty: false,
        itemsSelected: [
            {
                selectedCompetitor: { value: 'Unselected', label: '', color: '#DED9D9' },
                percentage: 100
            }
        ]
    };

    async componentDidMount() {
        var { colorIndex } = this.state;
        var { competitors, displayPeriod, user } = this.props;

        var isOpen = displayPeriod && displayPeriod.IsOpen;
        var isEligible = displayPeriod && displayPeriod.IsEligible;
        var canApprove = this.canApprove(isEligible);
        
        var submission = displayPeriod && displayPeriod.ExistingSubmission;
        var existingShares = submission && submission.CompetitorShares;
        var status = submission && submission.Status ? submission.Status : "In Process";
        var deniedBy = submission && submission.DeniedBy ? submission.DeniedBy : null;
        var itemsSelected = [];
        var total = 0;
        var otherTotal = 0;

        if(existingShares) {
            total = existingShares.reduce((sum, x) => sum + x.Percentage, 0);
            otherTotal = existingShares.filter(x => x.IsOther).reduce((sum, x) => sum + x.Percentage, 0);

            itemsSelected = existingShares.filter(x => x.Percentage > 0).map(x => {
                var competitor = competitors.find(y => x.Id === y.Id);
                var name = competitor == null ? x.OtherManufacturer : competitor.Name;

                var result =  {                   
                    selectedCompetitor: { id: x.Id, value: name, label: name, isOther: x.IsOther, color: colors[colorIndex] },
                    percentage: x.Percentage
                }

                colorIndex = (colorIndex + 1) % colors.length;

                return result;
            });

            if(status === "Denied" && user.CanSubmit && isEligible) {
                toastr.warning('These results have been denied.  Please make changes as needed and re-submit.');
            }
        }

        //add unselected to graph if not fully allocated
        if(total < 100) {
            itemsSelected.push({
                selectedCompetitor: { value: 'Unselected', label: '', color: '#DED9D9' },
                percentage: Math.round( (100 - Number(total)) * 10 ) / 10
            });
        }

        //10% or less should be allocated to "other" competitors
        if (otherTotal < 20) {
            competitors.push({ Name: 'Other', id: 'Other', isOther: true, Status: 'Active' });
        }

        //add 'other' manufacturers to dropdown
        this.state.itemsSelected
            .filter(item => item.selectedCompetitor.isOther)
            .forEach(item => competitors.push({ Name: item.selectedCompetitor.label, id: null, isOther: true, Status: 'Active' }));

        this.setState({
            competitors: competitors.map(c => ({ 
                value: c.Name, 
                label: c.Name, 
                id: c.Id, 
                isOther: c.isOther,
                Status: c.Status
            })),
            isOpen: isOpen,
            isEligible: isEligible,
            canApprove: canApprove,
            itemsSelected: itemsSelected,
            selectedCompetitor: null,
            percentage: '',
            showOtherField: false,
            otherCompetitor: '',
            totalSelected: total,
            totalOtherSelected: otherTotal,
            status: status,
            deniedBy: deniedBy,
            colorIndex: colorIndex
        });
    }

    canApprove = (isEligible) => {
        const { user } = this.props;
        const hasRequiredPermission = ((user.CanSubmit && user.IsDealerPrincipal) || user.IsAdmin || (user.CanSubmit && user.IsShareofAccountApprover));

        if(isEligible) {
            return hasRequiredPermission;
        } else {
            return false;
        }
    }


    handleCompetitorChange = (selectedOption) => {
        this.setState({ selectedCompetitor: selectedOption });
        if (selectedOption.label === 'Other') {
            this.setState({ showOtherField: true });
        } else {
            this.setState({ showOtherField: false });
        }
    }

    handleAddClick = async () => {
        const { otherCompetitor, selectedCompetitor, percentage } = this.state;
        var { colorIndex, totalSelected, totalOtherSelected, itemsSelected, competitors } = this.state;
        const pct = Math.round(Number(percentage) * 10) / 10;
        if (!Number.isFinite(pct)) {
            return;
        }
        const currentItem = { selectedCompetitor, percentage: pct };

        //handle invalid entry
        if(!selectedCompetitor || !selectedCompetitor.value) {
            return;
        }

        //can't modify unselected directly
        if(selectedCompetitor.value === '') {
            return;
        }

        //check if they are updating an existing item
        var matchingItem = itemsSelected.find(x => x.selectedCompetitor.value === selectedCompetitor.value);
        if(matchingItem != null) {
            currentItem.selectedCompetitor.color = matchingItem.selectedCompetitor.color;
            totalSelected = Math.round( (Number(totalSelected) - Number(matchingItem.percentage)) * 10 ) / 10;

            if(matchingItem.selectedCompetitor.isOther) {
                currentItem.selectedCompetitor.isOther = true;
                totalOtherSelected = Math.round( (Number(totalOtherSelected) - Number(matchingItem.percentage)) * 10 ) / 10;
            }
        }

        //update totals and validate
        totalSelected = Math.round((Number(totalSelected) + Number(currentItem.percentage)) * 10) / 10;
        totalOtherSelected = Number(totalOtherSelected) + (currentItem.selectedCompetitor.isOther ? Number(currentItem.percentage) : 0);

        if (this.validateMaxTotal(totalSelected)) {
            toastr.warning('The total allocation cannot exceed 100%');
            return;
        }

        if (currentItem.selectedCompetitor.isOther && this.validateOtherTotal(totalOtherSelected)) {
            toastr.warning('The percentage allocated to other competitors cannot exceed 20%');
            return;
        }

        //check for other
        if (selectedCompetitor.label === 'Other') {
            currentItem.selectedCompetitor = {
                value: otherCompetitor,
                label: otherCompetitor,
                isOther: true,
                Status: 'Active',
                color: currentItem.selectedCompetitor.color
            }
        }

        //ensures colors remain the same for each item
        if(currentItem.selectedCompetitor.color == null) {
            currentItem.selectedCompetitor.color = colors[colorIndex];
            colorIndex = (colorIndex + 1) % colors.length;
        }

        //add/remove items from graph as necessary
        if(matchingItem) {
            var index = itemsSelected.findIndex(x => x.selectedCompetitor.value === matchingItem.selectedCompetitor.value);
            itemsSelected.splice(index, 1);
        }

        if(pct > 0) {
            itemsSelected.push(currentItem);
        }

        var matchUnselected = itemsSelected.findIndex(x => x.selectedCompetitor.value === 'Unselected');

        if(matchUnselected > -1) {
            itemsSelected.splice(matchUnselected, 1);
        }

        if(totalSelected < 100) {
            itemsSelected.push({
                selectedCompetitor: { value: 'Unselected', label: '', color: '#DED9D9' },
                percentage: Math.round( (100 - Number(totalSelected)) * 10 ) / 10
            });
        }

        //add/remove 'other' manufacturer names
        competitors = competitors.filter(x => !x.isOther);
        itemsSelected
            .filter(x => x.selectedCompetitor.isOther)
            .forEach(x => competitors.push({ 
                value: x.selectedCompetitor.label, 
                label: x.selectedCompetitor.label, 
                id: null, 
                isOther: true,
                Status: 'Active'
            }));

        //add/remove the 'other' competitor
        var matchOther = competitors.findIndex(x => x.label === 'Other');

        if(totalOtherSelected >= 20 && matchOther > -1) {
            competitors.splice(matchOther, 1);
        } else if(totalOtherSelected < 20 && matchOther === -1) {
            competitors.push({label: 'Other', value: 'Other', id: null, isOther: true, Status: 'Active' });
        }

        this.setState({
            itemsSelected: itemsSelected,
            percentage: '',
            selectedCompetitor: null,
            showOtherField: false,
            otherCompetitor: '',
            competitors: competitors, 
            totalSelected: totalSelected,
            totalOtherSelected: totalOtherSelected,
            colorIndex: colorIndex,
            isDirty: true
        });
    }

    handleChartClick = (chartSelection) => {
        if(chartSelection.data.key === '') {
            this.setState({
                percentage: chartSelection.data.value
            });
        } else {
            var data = chartSelection.data;
            this.setState({
                percentage: chartSelection.data.value,
                selectedCompetitor: { value: data.key, label: data.key, id: data.id, isOther: data.isOther }
            });
        }
    }

    handleResetClick = async () => {
        this.setState({
            openReset: false,
            totalSelected: 0,
            totalOtherSelected: 0,
            colorIndex: 0,
            itemsSelected: [
                {
                    selectedCompetitor: { value: 'Unselected', label: '', color: '#DED9D9' },
                    percentage: 100
                }
            ]
        }, this.save);
    }

    handleSaveClick = () => {
        this.save();
    }

    handleSubmitClick = async () => {
        const { itemsSelected, isEligible, canApprove } = this.state;
        const { user, dealer, quarter, year } = this.props;

        this.setState({ openSubmit: false, isSubmitting: true });
        try {
            const result = await sharedAccountsApi.submit(quarter, year, dealer.Id, user, itemsSelected);
            if (result && result.data === true) {
                if (canApprove) {
                    const approveResult = await sharedAccountsApi.approve(
                        quarter,
                        year,
                        dealer.Id,
                        user,
                        itemsSelected
                    );
                    if (approveResult && approveResult.data === true) {
                        this.props.handleNext(isEligible);
                    }
                } else {
                    this.props.handleNext(isEligible);
                }
            }
        } catch (error) {
            toastr.error('An error has occurred; please try again later.');
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    handleApproveClick = async () => {
        const { itemsSelected, isEligible } = this.state;
        const { user, dealer, quarter, year } = this.props;

        this.setState({ isSubmitting: true });
        try {
            const result = await sharedAccountsApi.approve(quarter, year, dealer.Id, user, itemsSelected);
            if (result && result.data === true) {
                this.props.handleNext(isEligible);
            }
        } catch (error) {
            toastr.error('An error has occurred; please try again later.');
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    handleDenyClick = async () => {
        const { itemsSelected, isEligible } = this.state;
        const { user, dealer, quarter, year } = this.props;

        this.setState({ isSubmitting: true });
        try {
            const result = await sharedAccountsApi.deny(quarter, year, dealer.Id, user, itemsSelected);
            if (result && result.data === true) {
                this.props.handleNext(isEligible);
            }
        } catch (error) {
            toastr.error('An error has occurred; please try again later.');
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    handleChange = name => event => {
        const {percentage} = this.state;
        let value = event.target.value;

        if (name === 'percentage') {

            // regex:
            // a two digit number with one decimal point
            // OR a two digit integer
            // OR 100
            if (!value.match(/^((\d{0,2}\.\d?)|\d{0,2}|100)$/) || !isFinite(value)) {
                value = percentage;
            }

            this.setState({
                percentage: value
            });
        }

        if(name === 'otherCompetitor') {
            this.setState( {
                otherCompetitor: value
            })
        }
    };

    save = async () => {
        const {itemsSelected} = this.state;
        const {user, dealer, quarter, year} = this.props;

        await sharedAccountsApi.save(quarter, year, dealer.Id, user, itemsSelected)
        .then(result => {
            if (result && result.data === true) {
                this.setState({
                    isDirty: false
                });
            }
        })
        .catch(error => {
            toastr.error('An error has occurred; please try again later.');
        });
    }

    validateMaxTotal = total => {
        if (total > 100) {
            return true;
        }
        return false;
    }

    validateOtherTotal = total => {
        if (total > 20) {
            return true;
        }
        return false;
    }

    handleSubmitDialogOpen = () => {
        this.setState({ openSubmit: true });
    };

    handleSubmitDialogClose = () => {
        this.setState({ openSubmit: false });
    };

    handleResetDialogOpen = () => {
        this.setState({ openReset: true });
    };

    handleResetDialogClose = () => {
        this.setState({ openReset: false });
    };

    renderSubmitDialog() {
        const {openSubmit} = this.state;

        return (
            <div>
                <Dialog
                    open={openSubmit}
                    onClose={this.handleSubmitDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            I hereby agree that the provided information is accurate as best I can tell.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSubmitClick} color="primary" autoFocus>
                            Agree
                        </Button>
                        <Button onClick={ openSubmit ? this.handleSubmitDialogClose : this.handleResetDialogClose} color="primary">
                            Disagree
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    renderResetDialog() {
        const {openReset} = this.state;

        return (
            <div>
                <Dialog
                    open={openReset}
                    onClose={this.handleResetDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            This action will clear all previously entered data. Proceed?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleResetClick } color="primary" autoFocus>
                            Yes
                        </Button>
                        <Button onClick={this.handleResetDialogClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    getMessage() {
        const { status, isEligible, canApprove, deniedBy} = this.state;
        const { user, nextPeriod } = this.props;
        const canSubmit = (user.CanSubmit || user.IsAdmin);

        var message = "";
        var ineligibleMessage = "";
        var nextPeriodMessage = nextPeriod && nextPeriod.Start ? 
            "The next submission period will begin " + nextPeriod.Start + "." :
            "Check back next quarter!";
        
        if(isEligible) {

            if(status === "Approved") {
                message = "These results have been approved!";

                if(canSubmit) {
                    message += " " + nextPeriodMessage;
                }
            }

            if(status === "Submitted") {
                message = "These results have been submitted!";

                if(canApprove) {                   
                    message += " Please review the submission details and " + 
                        "verify the results using one of the buttons below.";
                } else if(canSubmit) {
                    message += " " + nextPeriodMessage;
                }
            }

        } else if(status === "Approved" || status === "Submitted") {
            ineligibleMessage = "Note: This submission was not completed in time to be eligible for funds.";
            message = nextPeriodMessage;

        } else if(status === "Denied") {
            if(deniedBy !== null) {
                ineligibleMessage = "Thank you for submitting Share of Account data but this was denied by " 
                + deniedBy 
                + ".  Please contact MktServ@honcompany.com for assistance.";
            } else {
                ineligibleMessage = "Thank you for submitting Share of Account data but this was denied.  Please contact MktServ@honcompany.com for assistance.";
            }

            message = nextPeriodMessage;
        }

        if(status === "Closed") {
            message = "The submission period for the current quarter is now closed.";
            message += " " + nextPeriodMessage;
        }

        return (
            <React.Fragment>
                <Typography component="h1" variant="h6" align="center">
                    {message}
                </Typography>
                <Typography component="h1" variant="h6" align="center">
                    {ineligibleMessage}
                </Typography>
            </React.Fragment>
        );
    }

    render() {
        const { showOtherField, selectedCompetitor, percentage, totalSelected, status, isDirty, canApprove, isOpen, isSubmitting } = this.state;
        const { user, displayPeriod } = this.props;
        const canSubmit = (user.CanSubmit || user.IsAdmin);
        const showGraph = displayPeriod != null;

        return (
            <React.Fragment>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1, backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                    open={isSubmitting}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Grid container justifyContent="center" alignItems="center" spacing={2}>
                    <Grid item xs={12}>                       
                        { this.getMessage() }                       
                    </Grid>
                    {(status === "In Process" || status === "Not Started" || (status === "Denied" && isOpen)) && canSubmit &&
                        <Grid container item xs={12} spacing={2} alignItems="center" sx={{ flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
                        <Competitor
                            selectedCompetitor={selectedCompetitor}
                            handleCompetitorChange={this.handleCompetitorChange}
                            percentageValue={percentage}
                            showOtherField={showOtherField}
                            competitors={this.state.competitors}
                            otherCompetitor={this.state.otherCompetitor}
                            totalOtherSelected={this.state.totalOtherSelected}
                            handleChange={this.handleChange}
                            handleAddClick={this.handleAddClick}
                        />
                        </Grid>
                    }

                    {showGraph && (
                        <Grid item xs={12}>
                            <SharedPieChart
                                itemsSelected={this.state.itemsSelected}
                                chartClick={this.handleChartClick}
                                competitors={this.state.competitors}
                            />
                        </Grid>
                    )}                  
                </Grid>

                <ThemeProvider theme={theme}>

                    {(status === "In Process" || status === "Not Started" || (status === "Denied" && isOpen)) && canSubmit &&
                        <Grid container justifyContent="space-between" alignItems="center" spacing={2} sx={{ mt: 2 }}>                  
                            <Grid item xs={12} sm="auto">
                                <Button variant="contained" color="primary" style={{ flex: 1 }}
                                    disabled={totalSelected === 0} 
                                    onClick={this.handleResetDialogOpen}>
                                    Reset
                                </Button>
                            </Grid>
                            <Grid container item xs={12} sm justifyContent="flex-end" alignItems="center" spacing={2}>
                                <Grid item>
                                    <Button variant="contained" color="primary"
                                        disabled={!isDirty}
                                        onClick={this.handleSaveClick}>
                                        {isDirty ? "Save" : "Saved, not submitted"}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" 
                                        disabled={totalSelected < 100} 
                                        onClick={this.handleSubmitDialogOpen}>
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                        
                    {status === "Submitted" && canApprove &&
                        <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}> 
                            <Grid item>
                                <Button variant="contained" color="primary" 
                                    disabled={totalSelected < 100}
                                    onClick={this.handleApproveClick}>
                                    Approve
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="primary"
                                    onClick={this.handleDenyClick}>
                                    Deny
                                </Button>
                            </Grid>                        
                        </Grid>
                    }

                </ThemeProvider>

                {this.renderSubmitDialog()}
                {this.renderResetDialog()}

            </React.Fragment>
        );
    }
}

export default withStyles(styles)(Item);



